import IdentityClient from "./IdentityClient";

const InvitationService = {
    async createInvite(data: any) {
        const result = await IdentityClient().post("/Invitation/create", data);
        return result.data;
    },
};

export default InvitationService;
